import type { ReactNode, ReactPortal } from 'react';
import { createPortal } from 'react-dom';

export class Curtain {
  private static curtain = document.querySelector('.curtain');

  public static resurrect(): void {
    if (this.curtain) {
      this.curtain.classList.remove('curtain_dead');
      this.curtain.classList.add('curtain_undead');
      this.curtain.classList.remove('curtain_lifted');
    }
  }

  public static renderContent(children: ReactNode): ReactPortal | null {
    if (this.curtain) {
      const portal = document.querySelector('.curtain__portal');
      if (portal) {
        return createPortal(children, portal);
      }
    }
    return null;
  }

  public static remove(): void {
    if (this.curtain && document.querySelector('.curtain')) {
      document.body.removeChild(this.curtain);
    }
  }
}
